export const notificationsZIndex = "z-index: 50;"

export const chartDropdownZIndex = 10

export const spacesBarZIndex = 8

export const spacePanelZIndex = 6

export const appHeaderZIndex = 5

// the same as in cloud
export const portalSidebarZIndex = "z-index: 35;"
export const customDropdownZIndex = "z-index: 45;"
export const dialogsZIndex = 60
